import PropTypes from "prop-types"
import { Link } from "react-router-dom"

import Image from "components/landing/image"
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "components/ui/carousel"
import { cn } from "styles/utils"

// Keep these styles in sync with the loading shimmer `areas/landing/loaders/collection-menu.jsx`

const defaultBubbleStyle = {
  borderRadius: "50%",
  style: { height: "auto" },
}

const LandingCollectionMenu = ({ element, handleItemClick, lazyload }) => {
  const properties = element?.data?.properties || {}
  const {
    className: carouselClassName,
    opts,
    ...carouselProps
  } = properties?.carouselProps || {}
  const {
    className: carouselContentClassName,
    viewportClassName,
    ...carouselContentProps
  } = properties?.carouselContentProps || {}
  const { className: carouselItemClassName, ...carouselItemProps } =
    properties?.carouselItemProps || {}
  const { className: itemTitleClassName, ...itemTitleProps } =
    properties?.itemTitleProps || {}
  const { className: carouselControlsClassName } =
    properties?.carouselControlsProps || {}
  const { disableSkip } = properties || {}

  return (
    <div {...properties?.containerProps}>
      <Carousel
        className={cn(element?.contain && "contained-wide", carouselClassName)}
        description={element?.data?.description}
        disableSkip={disableSkip}
        opts={{
          active: true,
          align: "start",
          breakpoints: {
            "(min-width: 1280px)": { active: false },
          },
          loop: false,
          slidesToScroll: "auto",
          ...opts,
        }}
        {...carouselProps}
      >
        <CarouselContent
          className={cn(
            "tablet:px-32 widescreen:px-60 large:justify-center tablet:gap-16 widescreen:gap-24 xlarge:gap-40 justify-start gap-8 px-16",
            carouselContentClassName
          )}
          style={{
            "--base-basis": "25vw",
            "--desktop-basis": "13vw",
            "--large-basis": "140px",
            "--tablet-basis": "18vw",
            "--xlarge-basis": "180px",
          }}
          viewportClassName={cn(
            "mask-fade-right large:mask-none widescreen:py-60 py-32",
            viewportClassName
          )}
          {...carouselContentProps}
        >
          {element.items.map((item, i) => {
            const image = {
              ...item.image,
              alt: "",
              sizes:
                "(max-width: 767px) 25vw,(max-width: 1023px) 18vw, (max-width: 1279px) 13vw, (max-width: 1919px) 140px, 180px",
              style: {
                ...defaultBubbleStyle,
                ...item.image?.style,
              },
            }
            const { className, ...titleProps } = item.title_style || {}
            return (
              <CarouselItem
                className={cn(
                  "xlarge:basis-(--xlarge-basis) large:basis-(--large-basis) desktop:basis-(--desktop-basis) basis-(--base-basis) tablet:basis-(--tablet-basis) text-center",
                  carouselItemClassName
                )}
                key={`${element.id}-${item.id}-${i}`}
                {...carouselItemProps}
              >
                <Link
                  className="block h-full"
                  data-lc={element.anchor_name || element.id}
                  onClick={() => handleItemClick && handleItemClick()}
                  to={item.url}
                >
                  <Image
                    containerStyle={{ px: 1 }}
                    image={image}
                    lazyload={lazyload}
                  />
                  <h2
                    className={cn(
                      "body widescreen:mt-8 tablet:px-8 xlarge:px-16 mt-8 px-12 font-semibold",
                      itemTitleClassName,
                      className
                    )}
                    {...itemTitleProps}
                    {...titleProps}
                  >
                    {item.title}
                  </h2>
                </Link>
              </CarouselItem>
            )
          })}
        </CarouselContent>
        <CarouselPrevious
          className={cn("large:hidden inline-flex", carouselControlsClassName)}
        />
        <CarouselNext
          className={cn("large:hidden inline-flex", carouselControlsClassName)}
        />
      </Carousel>
    </div>
  )
}

LandingCollectionMenu.propTypes = {
  element: PropTypes.object,
  handleItemClick: PropTypes.func,
  lazyload: PropTypes.bool,
}

export default LandingCollectionMenu
